<template>
  <!-- View project modal template -->
  <b-modal ref="view-guide" @hide="hideGuideModal" size="xl">

    <template #modal-header="{ close }">
      <div class="" style="width: 100%;">
        <span @click="closeModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
          <font-awesome-icon icon="times"/>
        </span>
          <h3 qid="guide-view-title" class="mb-2">
            {{ guide.title }}
          </h3>
      </div>
    </template>

    <div class="mt-4"  style="font-size: 18px;" v-if="guide && guide.id">
      <p class="text-formatted" v-html="guide.description"></p>

      <div v-if="guide.media && guide.media.length" class="mt-3">
        <label>{{ $t('system.media_label') }}</label>
      </div>
      <div v-for="media in guide.media">
        <video width="318" controls :src="media.url"></video>
      </div>
    </div>

    <template #modal-footer="{ close }">
      <div class="" style="width: 100%;">
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="modal-inner-footer">
              <b-form-checkbox
                v-model="doNotShowGuide"
                name="checkbox-disable"
                :value="1"
                class="float-left mt-4"
                :unchecked-value="0"
                v-if="showCheckbox"
              >
                {{ $t('system.dont_show_again') }}
              </b-form-checkbox>
              <div class="text-right">
                <b-button class="mt-4 float-right"
                          variant="secondary"
                          @click="closeModal"
                          qid="create-p-cancel-button"
                >
                  {{ $t('processes.policies.view.close') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'GuideViewModal',
    data: function() {
      return {
        error: '',
        showCheckbox: false,
        doNotShowGuide: 0
      }
    },
    props: {
      guide: {},
      showModal: {
        type: Boolean
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showGuideModal()
        }
      }
    },
    methods: {
      showGuideModal() {
        this.showCheckbox = false;
        if (this.guide && (this.guide.scope == 'update_task' || this.guide.scope == 'validation_task' || this.guide.scope == 'control_task' || this.guide.scope == 'assessment_task')) {
          this.showCheckbox = true;
        }
        let self = this
        this.$refs['view-guide'].show()
      },
      hideGuideModal() {
        let self = this;
        if (this.doNotShowGuide) {
          let apiParams = {}
          if (this.guide.scope == 'update_task') {
            apiParams = {
              hide_update_task_guide: true
            }
          }
          if (this.guide.scope == 'validation_task') {
            apiParams = {
              hide_validation_task_guide: true
            }
          }
          if (this.guide.scope == 'control_task') {
            apiParams = {
              hide_control_task_guide: true
            }
          }
          if (this.guide.scope == 'assessment_task') {
            apiParams = {
              hide_assessment_task_guide: true
            }
          }

          piincHttp.put('users/' + this.getUser.slug, apiParams).then(function(response) {
            let user = self.getUser
            user.hide_update_task_guide = response.data.hide_update_task_guide
            user.hide_validation_task_guide = response.data.hide_validation_task_guide
            user.hide_control_task_guide = response.data.hide_control_task_guide
            user.hide_assessment_task_guide = response.data.hide_assessment_task_guide
            self.$store.commit('storeUser', user);
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })

        }
        this.error = ''
        this.$emit('closeViewModal');
        this.$refs['view-guide'].hide()
      },
      closeModal() {
        this.$refs['view-guide'].hide()
      }
    },
    created () {

    }
  }
</script>
